<!-- Sidebar -->
<app-sidebar />

<!-- Overall Screen Scroll (Scrollbar on the right edge of screen) -->
<ng-scrollbar class="flex-1 h-screen" visibility="hover">
    <div class="main-content transition-all min-h-screen flex flex-col">

        <!-- Header -->
        <app-header />

        <!-- Router Outlet -->
        <router-outlet />

        <div class="grow"></div>

        <!-- Footer -->
        <app-footer />

    </div>
</ng-scrollbar>